import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { breakTitle } from '../../../../../shared/utils/break-title';
import {
  getIconByUnterrichtsformId,
  LernformIcon
} from '../../../../../shared/utils/get-icon-by-unterrichtsform-id.util';
import { getLernformText } from '../../../../../shared/utils/get-lernform-text.util';
import { BildungsangebotTerminDetail } from '../../../../../model';
import { SanitizerService } from '../../../../../services/sanitizer.service';
import { ChipComponent } from '../../../../chip/chip.component';

@Component({
  selector: 'now-wbsuche-lib-weiterbildungsinformationen',
  templateUrl: './weiterbildungsinformationen.component.html',
  styleUrls: ['../keywords.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ChipComponent]
})
export class WeiterbildungsinformationenComponent {
  private readonly sanitizerService = inject(SanitizerService);

  @Input()
  public termin!: BildungsangebotTerminDetail;

  sanitizeFunction(word: string) {
    return this.sanitizerService.sanitize(word);
  }

  sanitizeAndBreakTitle(word: string): string {
    const sanitized = this.sanitizeFunction(word);
    return breakTitle(sanitized);
  }

  getIconByUnterrichtsformId(id: number): LernformIcon {
    return getIconByUnterrichtsformId(id);
  }

  getLernform(): string {
    return getLernformText(this.termin);
  }

  getIconByUnterrichtszeitId(id: number): LernformIcon {
    return getIconByUnterrichtsformId(id);
  }

  getBarriereFreiheit() {
    if (this.termin.digitaleBarrierefreiheit && this.termin.adresse?.barrierefrei) {
      return 'Räumliche und digitale Barrierefreiheit';
    }
    if (this.termin.digitaleBarrierefreiheit) {
      return 'Digitale Barrierefreiheit';
    }
    if (this.termin.adresse?.barrierefrei) {
      return 'Räumliche Barrierefreiheit';
    }
    return '';
  }
}
